import React from "react";
import Checkbox from "../ui/inputs/checkBox/CheckBox";
import PropTypes from "prop-types";

const CommonIncludeInactiveFilter = (props) => {
  return (
    <div className={`ml-2 ${props.containerCss ? props.containerCss : ""}`}>
      <Checkbox
        key={props.key || "inlucdeInactive"}
        name={props.name || "inlucdeInactive"}
        label={props.label || "Include Inactive"}
        isDisable={props.isDisable}
        dataField={props.dataField}
        onChange={props.onChange}
        checked={props.includeInactive}
      />
    </div>
  );
};

CommonIncludeInactiveFilter.propTypes = {
  containerCss: PropTypes.string,
  key: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  isDisable: PropTypes.bool,
  dataField: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  includeInactive: PropTypes.bool.isRequired,
};

export default CommonIncludeInactiveFilter;
